import { render } from "./UserManager.vue?vue&type=template&id=d937973c&scoped=true"
import script from "./UserManager.vue?vue&type=script&lang=js"
export * from "./UserManager.vue?vue&type=script&lang=js"

import "./UserManager.vue?vue&type=style&index=0&id=d937973c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d937973c"]])

export default __exports__